import { render, staticRenderFns } from "./HotSale.vue?vue&type=template&id=7d2f59c7&scoped=true"
import script from "./HotSale.vue?vue&type=script&lang=js"
export * from "./HotSale.vue?vue&type=script&lang=js"
import style0 from "./HotSale.vue?vue&type=style&index=0&id=7d2f59c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f59c7",
  null
  
)

export default component.exports